// extracted by mini-css-extract-plugin
export default {"add-button":"add-button_add-button__mzkaF","add-button--dark":"add-button_add-button--dark__wIIjH","icon-21":"add-button_icon-21__WwnXz","icon-24":"add-button_icon-24__boTXz"};